import React, {Component} from "react";
import PropTypes from "prop-types";
import {Redirect} from 'react-router';
import {NavLink} from 'react-router-dom';
import Loader from '../Loader'
import api from "../../api/Api";

import ReactTable from "react-table";
import "react-table/react-table.css";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";
import Datetime from "react-datetime";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import moment from "moment";
import Tooltip from "@material-ui/core/Tooltip";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
// core components
import GridItem from "components/Grid/GridItem.jsx";
//import Table from "components/Table/Table.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardText from "components/Card/CardText.jsx";
import matchSorter from 'match-sorter';
import Button from "components/CustomButtons/Button.jsx";
import Icon from '@material-ui/core/Icon';
import LocalHospital from "@material-ui/icons/Assignment";
import SearchComponent from "components/Search/AutoCompletePatient.jsx";

//import AlertBox from 'components/AlertBox/alertbox.jsx';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';

import GridContainer from "components/Grid/GridContainer.jsx";

import {
    mappingUI,
    dashboardRouter,
    isClinicMasterOrClinic,
    getClinicUserId, getDateConverter,
    getReportTypes
} from '../../util/globalHelper';
import Permissions from '../../util/globalPermissions';

const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    AutoCompleteClass: {
        width: '100%',
        padding: 0,
        margin: '20px 0',
        height: 0,
        position: 'inherit'
    }
};

class Campaigns extends Component {
    constructor() {
        super();
        this.state = {
            data: null,
            clinicsData: null,
            simpleSelect: "",
            doctorsData: null,
            start_date: moment().format('YYYY-MM-DD'),
            end_date: moment().format('YYYY-MM-DD'),
            clinic_id: "",
            doctor_id: "",
            patientId: "",
            type: "",
            open: true,
            alert: null,
            notFound: null,
            patient: null
        };
        this.onChangeSelect = this.onChangeSelect.bind(this);
        this.searchOnFilter = this.searchOnFilter.bind(this);
        this.hideAlert = this.hideAlert.bind(this);
        this.CreateAlert = this.CreateAlert.bind(this)
    }

    handleChangeStartDate(event) {
        this.setState({start_date: event.format('YYYY-MM-DD')});
    }

    handleChangeEndDate(event) {
        this.setState({end_date: event.format('YYYY-MM-DD')});
    }

    handleSimple = event => {
        this.setState({[event.target.name]: event.target.value});
    };

    CallReadApi = () => {
        api.getCampaign({
            // start_date: moment().format('YYYY-MM-DD'),
            // end_date: moment().format('YYYY-MM-DD')
        }).then(json => {
            this.setState({
                data: json.data.data.map(item => {
                    return {
                        "_id": item._id,
                        "name": item.name ? item.name : "",
                        "content": item.content,
                        "type": item.push && item.sms ? "Both" : item.push ? "Push" : "SMS",
                        "date": item.created_at,
                        "status": item.status
                    }
                })
            })
        }).catch(error => {
            this.setState({notFound: error, data: []})
        });
        isClinicMasterOrClinic() === "" || isClinicMasterOrClinic() ?
            api.listClinics().then(json => {
                this.setState({clinicsData: json.data.data})
            }) : this.setState({clinicsData: {}});
        api.getAllDoctors().then(json => {
            this.setState({doctorsData: json.data.data})
        });
        this.setState({clinic_id: getClinicUserId()})
    }

    componentDidMount() {
        this.CallReadApi();
    }

    searchOnFilter() {
        this.setState({data: null});
        var postBody = {
            clinic_id: this.state.clinic_id,
            // patient_id: this.state.patientId,
            // doctor_id: this.state.doctor_id,
            start_date: this.state.start_date,
            end_date: this.state.end_date,
            // type: this.state.simpleSelect
        };
        api.getCampaign(postBody).then(json => {
            this.setState({
                data: json.data.data.map(item => {
                    return {
                        "_id": item._id,
                        "name": item.name ? item.name : "",
                        "content": item.content,
                        "type": item.push && item.sms ? "Both" : item.push ? "Push" : "SMS",
                        "date": item.created_at,
                        "status": item.status
                    }
                })
            })
        }).catch(err => {

        });
    }


    getSuggestionValue = (suggestion) => {
        this.setState({
            patientId: suggestion._id,
            patient: suggestion,

        });
        return suggestion.user_id.name
    };

    clearPatient = () => {
        this.setState({patient: null, patientId: ""})
    };

    hideAlert() {
        this.setState({alert: null})
    }

    CreateAlert(id) {
        this.setState({
            alert: (
                <Dialog
                    open={this.state.open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">{"Are you sure want to delete?"}</DialogTitle>
                    <DialogActions style={{margin: '8px auto'}}>
                        <Button color="danger" onClick={() => {
                            this.deleteRecord(id)
                        }}>
                            Delete
                        </Button>
                        <Button onClick={this.hideAlert}>
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
            )
        });
    }

    deleteRecord(id) {
        var postBody = {"_id": id, "updated_object": {}};
        api.deleteReport(postBody)
            .then(json => {
                // window.location.reload();
                // window.location.reload();
                this.setState({alert:null});
                this.searchOnFilter();
            });
    }

    onChangeSelect(e) {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState(state);
    }

    render() {
        const {data, clinicsData, doctorsData} = this.state;
        const {classes} = this.props;
        if (this.state.clinicsData && this.state.doctorsData)
            return (
                <div>
                    {this.state.alert}
                    <Grid container>
                        {mappingUI(Permissions.UploadReports) ? <GridItem xs={12} sm={12} md={2}>
                            {/*<NavLink to={dashboardRouter("/report/add")}>*/}
                            {/*<Button block color="warning">*/}
                            {/*<Icon>add</Icon>*/}
                            {/*<span style={{paddingLeft: 10}}>ADD NEW</span>*/}
                            {/*</Button>*/}
                            {/*</NavLink>*/}
                        </GridItem> : null}
                        <GridItem xs={12} sm={12} md={12}>
                            <Card>
                                <CardHeader color="info" text>
                                    <CardText color="info">
                                        <GridContainer>
                                            <GridItem>
                                                <LocalHospital style={{marginTop: 10}}/>
                                            </GridItem>

                                            <GridItem>
                                                <h4 className={classes.cardTitleWhite}>Campaigns</h4>
                                                <p className={classes.cardCategoryWhite}>
                                                    List of all Campaigns
                                                </p>
                                            </GridItem>
                                        </GridContainer>
                                    </CardText>
                                </CardHeader>
                                <CardBody>
                                    <div>
                                        <GridContainer>
                                            <GridItem xs={12} sm={4} md={4} className="centerDiv">
                                                <FormControl fullWidth>
                                                    <Datetime
                                                        timeFormat={false}
                                                        value={this.state.start_date}
                                                        // defaultValue={new Date()}
                                                        dateFormat={"DD MMMM, YYYY"}
                                                        closeOnSelect={true}
                                                        name="start_date"
                                                        onChange={event => this.handleChangeStartDate(event)}
                                                        inputProps={{placeholder: "Start Date"}}/>
                                                </FormControl>
                                            </GridItem>
                                            {isClinicMasterOrClinic() === "" || isClinicMasterOrClinic() ?

                                                <GridItem xs={12} sm={4} md={4} className="centerDiv">
                                                    <FormControl
                                                        fullWidth
                                                        className={classes.selectFormControl}>
                                                        <InputLabel
                                                            htmlFor="clinic_id"
                                                            className={classes.selectLabel}>
                                                            Clinic
                                                        </InputLabel>
                                                        <Select
                                                            MenuProps={{
                                                                className: classes.selectMenu
                                                            }}
                                                            classes={{
                                                                select: classes.select
                                                            }}
                                                            value={this.state.clinic_id}
                                                            onChange={this.onChangeSelect}
                                                            inputProps={{
                                                                name: "clinic_id",
                                                                id: "clinic_id"
                                                            }}
                                                        >
                                                            <MenuItem
                                                                disabled
                                                                classes={{
                                                                    root: classes.selectMenuItem
                                                                }}>
                                                                Select Clinic
                                                            </MenuItem> <MenuItem
                                                            value={""}
                                                            classes={{
                                                                root: classes.selectMenuItem
                                                            }}>
                                                            All Clinics
                                                        </MenuItem>
                                                            {clinicsData.map((x) => {
                                                                return <MenuItem key={Math.random()}
                                                                                 classes={{root: classes.selectMenuItem}}
                                                                                 style={{height: "1.8em"}}
                                                                                 value={x.clinic_id}>{x.clinic_name ? x.clinic_name : "No Name"}</MenuItem>
                                                            })}
                                                        </Select>
                                                    </FormControl>
                                                </GridItem> : null}
                                            <GridItem xs={12} sm={4} md={4} className="centerDiv">
                                                {/*<SearchComponent*/}
                                                {/*clearPatient={this.clearPatient}*/}
                                                {/*patient={this.state.patient}*/}
                                                {/*class={styles.AutoCompleteClass}*/}
                                                {/*getSuggestionValue={this.getSuggestionValue}/>*/}
                                            </GridItem>
                                        </GridContainer>
                                        <br/>

                                        <GridContainer>
                                            <GridItem xs={12} sm={4} md={4} className="centerDiv">
                                                <FormControl fullWidth>
                                                    <Datetime
                                                        timeFormat={false}
                                                        value={this.state.end_date}
                                                        name="end_date"
                                                        // defaultValue={new Date()}
                                                        dateFormat={"DD MMMM, YYYY"}
                                                        closeOnSelect={true}
                                                        onChange={event => this.handleChangeEndDate(event)}
                                                        inputProps={{placeholder: "End Date"}}/>
                                                </FormControl>
                                            </GridItem>
                                            <GridItem xs={12} sm={4} md={4} className="centerDiv">

                                            </GridItem>
                                            <GridItem xs={12} sm={4} md={4} className="centerDiv">


                                            </GridItem>
                                        </GridContainer>
                                        <br/>

                                        <GridContainer>
                                            <GridItem xs={12} sm={12} md={12} className="centerDiv">
                                                <Button color="warning" size="lg"
                                                        onClick={this.searchOnFilter}>Search</Button>
                                            </GridItem>
                                        </GridContainer>

                                    </div>
                                    <br/>
                                    {data !== null && data.length >= 0 ?
                                        <ReactTable
                                            data={data}
                                            filterable
                                            defaultFilterMethod={(filter, row) =>
                                                String(row[filter._id]) === filter.value}
                                            columns={[
                                                {
                                                    columns: [
                                                        {
                                                            Header: "Name",
                                                            accessor: "name",
                                                            // Cell: ({index}) =>
                                                            //     (<div>
                                                            //             <p style={{cursor: 'pointer'}}>
                                                            //                 {data[index].patient_id ? data[index].patient_id.user_id.name : "No Name"}
                                                            //             </p>
                                                            //         </div>
                                                            //     ),
                                                            filterMethod: (filter, rows) =>
                                                                matchSorter(rows, filter.value, {keys: ["name"]}),
                                                            filterAll: true
                                                        },
                                                        {
                                                            Header: "Content",
                                                            accessor: "content",
                                                            Cell: ({index}) =>
                                                                (<div>
                                                                        <p>{data[index].content ? data[index].content : "No Content"}</p>

                                                                    </div>
                                                                ),
                                                            // filterMethod: (filter, rows) =>
                                                            //     matchSorter(rows, filter.value, {keys: ["paid"]}),
                                                            // filterAll: true

                                                        }, {
                                                            Header: "Type",
                                                            accessor: "type",
                                                            Cell: ({index}) =>
                                                                (<div>
                                                                        <p>{data[index].type ? data[index].type : "No Type"}</p>

                                                                    </div>
                                                                ),
                                                            // filterMethod: (filter, rows) =>
                                                            //     matchSorter(rows, filter.value, {keys: ["paid"]}),
                                                            // filterAll: true

                                                        },
                                                        {
                                                            Header: "Status",
                                                            Cell: ({index}) =>
                                                                (<div>
                                                                        <p>{data[index].status ? data[index].status : "No Type"}</p>
                                                                    </div>
                                                                ),
                                                            filterable: false,
                                                            sortable: false,
                                                        },
                                                        {
                                                            Header: "Date",
                                                            Cell: ({index}) =>
                                                                (<div>
                                                                        <p>{data[index].date ? getDateConverter(data[index].date) : "No Date"}</p>

                                                                    </div>
                                                                ),
                                                            filterable: false,
                                                            sortable: false,
                                                        },
                                                        {
                                                            Header: 'Actions',
                                                            id: 'request_state',
                                                            filterable: false,
                                                            sortable: false,
                                                            Cell: ({index}) =>
                                                                (<div>
                                                                    {/*<Tooltip*/}
                                                                    {/*id="tooltip-top"*/}
                                                                    {/*title="View"*/}
                                                                    {/*placement="bottom"*/}
                                                                    {/*classes={{tooltip: classes.tooltip}}>*/}
                                                                    {/*<Button type="button" color="info"*/}
                                                                    {/*style={{*/}
                                                                    {/*padding: 8,*/}
                                                                    {/*marginLeft: '10%'*/}
                                                                    {/*}}>*/}
                                                                    {/*<Icon*/}
                                                                    {/*style={{fontSize: 20}}>info</Icon>*/}
                                                                    {/*</Button>*/}
                                                                    {/*</Tooltip>*/}
                                                                    <NavLink
                                                                        to={dashboardRouter(`/marketing/recampaign/${data[index]._id}`)}>
                                                                        <Tooltip
                                                                            id="tooltip-top"
                                                                            title="Rerun"
                                                                            placement="bottom"
                                                                            classes={{tooltip: classes.tooltip}}>
                                                                            <Button type="button" color="info"
                                                                                    style={{
                                                                                        padding: 8,
                                                                                        marginLeft: '10%'
                                                                                    }}
                                                                                    onClick={() => {
                                                                                        // this.props.id.hideAlert.push('/marketing/recampaign/' + data[index]._id)
                                                                                    }}>
                                                                                <Icon style={{fontSize: 20}}>info</Icon>
                                                                            </Button>
                                                                        </Tooltip>
                                                                    </NavLink>
                                                                    <NavLink
                                                                        to={dashboardRouter(`/marketing/edit/campaign/${data[index]._id}`)}>
                                                                        <Tooltip
                                                                            id="tooltip-top"
                                                                            title="Edit"
                                                                            placement="bottom"
                                                                            classes={{tooltip: classes.tooltip}}>
                                                                            <Button type="button" color="success"
                                                                                    style={{
                                                                                        padding: 8,
                                                                                        marginLeft: '5%'
                                                                                    }}>
                                                                                <Icon
                                                                                    style={{fontSize: 20}}>edit</Icon>
                                                                            </Button>
                                                                        </Tooltip>
                                                                    </NavLink>
                                                                </div>)
                                                        }]
                                                }
                                            ]}
                                            defaultPageSize={10}
                                            className="-striped -highlight"
                                        />
                                        : <Loader/>
                                    }
                                </CardBody>
                            </Card>
                        </GridItem>
                    </Grid>
                </div>
            );
        else return (
            <div>
                <Loader/>
            </div>
        )
    }
}

export default withStyles(styles)(Campaigns);



// WEBPACK FOOTER //
// ./src/components/Marketing/CampaignList.jsx